import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm">
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-2">
          {i > 0 && (
            <i className="ri-arrow-right-s-line text-foreground-400 text-xs" />
          )}
          {item.path ? (
            <Link
              to={item.path}
              className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              {item.name}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium whitespace-nowrap">{item.name}</span>
          )}
        </span>
      ))}
    </nav>
  );
}